import React from 'react';

const ScanTicket = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6">Scan Ticket</h1>
      <p className="text-gray-600">QR scanner - to be implemented</p>
    </div>
  );
};

export default ScanTicket;

